/**
 * 配置管理模块 - 运行时获取配置
 * 方便线上直接修改config.json而不需要重新打包
 */

const CONFIG_STORAGE_KEY = '28project_config';
let config = null;
let configPromise = null;

/**
 * 从localStorage加载配置
 */
function loadConfigFromStorage() {
  try {
    const storedConfig = localStorage.getItem(CONFIG_STORAGE_KEY);
    if (storedConfig) {
      return JSON.parse(storedConfig);
    }
  } catch (error) {
    console.error('从localStorage加载配置失败:', error);
  }
  return null;
}

/**
 * 保存配置到localStorage
 */
function saveConfigToStorage(cfg) {
  try {
    localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(cfg));
  } catch (error) {
    console.error('保存配置到localStorage失败:', error);
  }
}

/**
 * 获取配置（异步）
 * 每次都重新请求config.json，确保获取最新配置
 * @returns {Promise<Object>} 配置对象
 */
async function getConfig() {
  if (configPromise) {
    return configPromise;
  }

  configPromise = fetch('/static/config.json')
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to load config.json');
      }
      return response.json();
    })
    .then(data => {
      config = data;
      // 保存到localStorage
      saveConfigToStorage(config);
      return config;
    })
    .catch(error => {
      console.error('加载配置文件失败:', error);
      // 如果请求失败，尝试从localStorage读取
      const storedConfig = loadConfigFromStorage();
      if (storedConfig) {
        config = storedConfig;
        return config;
      }
      // 如果localStorage也没有，返回默认配置
      config = {
        API_ROOT: 'http://localhost:8080'
      };
      return config;
    });

  return configPromise;
}

/**
 * 获取配置（同步）
 * 如果配置还未加载完成，从localStorage读取或返回默认配置
 * @returns {Object} 配置对象
 */
function getConfigSync() {
  if (config) {
    return config;
  }
  // 如果配置还未加载，尝试从localStorage读取
  const storedConfig = loadConfigFromStorage();
  if (storedConfig) {
    config = storedConfig;
    return config;
  }
  // 如果localStorage也没有，返回默认配置
  return {
    API_ROOT: 'http://localhost:8080'
  };
}

/**
 * 获取API根地址（异步）
 * @returns {Promise<string>} API根地址
 */
async function getApiRoot() {
  const cfg = await getConfig();
  return cfg.API_ROOT;
}

/**
 * 获取API根地址（同步）
 * 如果配置还未加载完成，从localStorage读取或返回默认地址
 * @returns {string} API根地址
 */
function getApiRootSync() {
  const cfg = getConfigSync();
  return cfg.API_ROOT;
}

/**
 * 获取PDF API根地址（同步）
 * 如果配置还未加载完成，从localStorage读取或返回默认地址
 * @returns {string} PDF API根地址
 */
function getPdfApiRootSync() {
  const cfg = getConfigSync();
  return cfg.PDF_API_ROOT;
}

/**
 * 重置配置（用于测试或重新加载）
 */
function resetConfig() {
  config = null;
  configPromise = null;
  localStorage.removeItem(CONFIG_STORAGE_KEY);
}

export default {
  getConfig,
  getConfigSync,
  getApiRoot,
  getApiRootSync,
  getPdfApiRootSync,
  resetConfig
};



// WEBPACK FOOTER //
// ./src/config/index.js